import CreatePropertyForm from "@/components/property-form/CreatePropertyForm";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

const CreateProperty = () => {
  const navigate = useNavigate();

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      {/* Header */}
      <div className="mb-8">
        <div className="flex items-center gap-4 mb-4">
          <Button
            variant="ghost"
            size="sm"
            onClick={() => navigate("/admin")}
            className="p-2"
          >
            <ArrowLeft className="h-4 w-4" />
          </Button>
          <div>
            <h1 className="text-3xl font-bold text-gray-900">
              Crear Nueva Propiedad
            </h1>
            <p className="text-gray-600 mt-1">
              Completa todos los campos para crear una nueva propiedad
            </p>
          </div>
        </div>

        {/* Breadcrumb */}
        <nav className="flex items-center space-x-2 text-sm text-gray-500">
          <button
            onClick={() => navigate("/admin")}
            className="hover:text-gray-700"
          >
            Admin
          </button>
          <span>/</span>
          <span className="text-gray-900">Nueva Propiedad</span>
        </nav>
      </div>

      {/* Form */}
      <CreatePropertyForm />
    </div>
  );
};

export default CreateProperty;
